export default __webpack_public_path__ + "static/media/Ellipse4.9ea490b3.png";